import axios from 'axios'
import {API} from 'src/feature/bite/domain'

export default async function getSubCategories({
  merchantCategoryID,
}: {
  merchantCategoryID: string[]
}) {
  const response = await axios.post<any>(`${API}/Merchant/GetMerchantSubCategoryList`, {
    language: 'en',
    merchantCategoryIDs: merchantCategoryID,
  })
  return response?.data?.response?.dataList
}
